<template>
    <div id="app">
      <router-view />
        <!-- <router-view v-if="isRouterAlive" /> -->
        <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'webfont';
  font-display: swap;
  src: url('//at.alicdn.com/t/webfont_bitw8930ulu.eot'); /* IE9*/
  src: url('//at.alicdn.com/t/webfont_bitw8930ulu.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('//at.alicdn.com/t/webfont_bitw8930ulu.woff2') format('woff2'),
  url('//at.alicdn.com/t/webfont_bitw8930ulu.woff') format('woff'), /* chrome、firefox */
  url('//at.alicdn.com/t/webfont_bitw8930ulu.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
  url('//at.alicdn.com/t/webfont_bitw8930ulu.svg#NotoSansHans-DemiLight') format('svg'); /* iOS 4.1- */
}
html,body,#app {
    height: 100%;
    margin:0;
    font-family: 'webfont',"Avenir", Helvetica, Arial, sans-serif,"Microsoft YaHei"; 
}
ol,ul {list-style:none} 
a{text-decoration: none;color:#333;}
.qingwu{height: 100%;}
</style>
